import React from 'react';
import { authenticationRoute } from '@/modules/core/auth/route';
import { createRoute } from '@tanstack/react-router';

export const resetPasswordConfirmRoute = createRoute({
  getParentRoute: () => authenticationRoute,
  path: 'reset-password-confirm/$token',
  component: React.lazy(
    async () => await import('@/containers/ResetPasswordContainer/ConfirmPassword')
  ),
  wrapInSuspense: true,
});
